import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  workshopData: [],
  submitData: {},
  eventInfo: null,
};

const eventFormSlice = createSlice({
  name: "eventForm",
  initialState,
  reducers: {
    setWorkshopData: (state, action) => {
      state.workshopData = action.payload;
    },
    setSubmitData: (state, action) => {
      state.submitData = action.payload;
    },
    setEventInfo: (state, action) => {
      state.eventInfo = action.payload;
    },
    resetEventForm: () => initialState,
  },
});

export const {
  setWorkshopData,
  setSubmitData,
  setEventInfo,
  resetEventForm,
} = eventFormSlice.actions;

export default eventFormSlice.reducer;
